import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import Navbar from './components/Navbar';
import LoadingSpinner from './components/LoadingSpinner';
import MobileBindingModal from './components/MobileBindingModal';
import WhatsAppStickyButton from './components/WhatsAppStickyButton';
import { AuthProvider } from './contexts/AuthContext';

// Lazy load pages for better performance
const LandingPage = lazy(() => import('./pages/LandingPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const SignupPage = lazy(() => import('./pages/SignupPage'));
/*const DesignPage = lazy(() => import('./pages/DesignPage'));*/
const AIDesignPage = lazy(() => import('./pages/AIDesignPage'));
/* MANUAL DESIGN - DISABLED */
// const ManualDesignPage = lazy(() => import('./pages/ManualDesignPage'));
const MyDesignsPage = lazy(() => import('./pages/MyDesignsPage'));
const OrderConfirmationPage = lazy(() => import('./pages/OrderConfirmationPage'));
const OrderSuccessPage = lazy(() => import('./pages/OrderSuccessPage'));
const ContestPage = lazy(() => import('./pages/ContestPage'));
const ContestTermsPage = lazy(() => import('./pages/ContestTermsPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const CookiesPage = lazy(() => import('./pages/CookiesPage'));

// Admin pages
const AdminLoginPage = lazy(() => import('./pages/admin/AdminLoginPage'));
const AdminDashboardPage = lazy(() => import('./pages/admin/AdminDashboardPage'));
const AdminUsersPage = lazy(() => import('./pages/admin/AdminUsersPage'));
const AdminOrdersPage = lazy(() => import('./pages/admin/AdminOrdersPage'));
const ContestSettingsPage = lazy(() => import('./pages/admin/ContestSettingsPage'));
const AdminAIDesignSettingsPage = lazy(() => import('./pages/admin/AdminAIDesignSettingsPage'));

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname === '/admin' || location.pathname.startsWith('/admin/');

  return (
    <div className="min-h-screen bg-white">
      <MobileBindingModal />
      {!isAdminRoute && <WhatsAppStickyButton />}
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {/* Redirect home page to contest page */}
          {/* <Route path="/" element={<Navigate to="/contest" replace />} /> */}

          {/* Keep landing page accessible via /landing for future use */}
          <Route path="/" element={
            <div>
              <Navbar />
              <main>
                <LandingPage />
              </main>
            </div>
          } />

          <Route path="/login" element={
            <div>
              <Navbar />
              <main>
                <LoginPage />
              </main>
            </div>
          } />
          <Route path="/signup" element={
            <div>
              <Navbar />
              <main>
                <SignupPage />
              </main>
            </div>
          } />
          <Route path="/terms" element={
            <div>
              {/* <Navbar /> */}
              <main>
                <TermsPage />
              </main>
            </div>
          } />
          <Route path="/privacy" element={
            <div>
              {/* <Navbar /> */}
              <main>
                <PrivacyPage />
              </main>
            </div>
          } />
          <Route path="/cookies" element={
            <div>
              {/* <Navbar /> */}
              <main>
                <CookiesPage />
              </main>
            </div>
          } />
          {/* <Route path="/design" element={
            <div>
              <Navbar />
              <main>
                <DesignPage />
              </main>
            </div>
          } /> */}
          <Route path="/design/ai" element={
            <div>
              <Navbar />
              <main>
                <AIDesignPage />
              </main>
            </div>
          } />
          {/* MANUAL DESIGN - DISABLED */}
          {/* <Route path="/design/manual" element={
            <div>
              <Navbar />
              <main>
                <ManualDesignPage />
              </main>
            </div>
          } /> */}
          <Route path="/my-designs" element={
            <div>
              <Navbar />
              <main>
                <MyDesignsPage />
              </main>
            </div>
          } />
          <Route path="/order-confirmation" element={
            <div>
              <Navbar />
              <main>
                <OrderConfirmationPage />
              </main>
            </div>
          } />
          <Route path="/order-success" element={
            <div>
              <Navbar />
              <main>
                <OrderSuccessPage />
              </main>
            </div>
          } />



          {/* Contest routes */}
          <Route path="/contest" element={
            <main>
              <ContestPage />
            </main>
          } />
          <Route path="/contest-terms" element={
            <main>
              <ContestTermsPage />
            </main>
          } />

          {/* Admin routes without navbar */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/orders" element={<AdminOrdersPage />} />
          <Route path="/admin/contest-settings" element={<ContestSettingsPage />} />
          <Route path="/admin/ai-design-settings" element={<AdminAIDesignSettingsPage />} />
        </Routes>
      </Suspense>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
